'use client';
import dynamic from 'next/dynamic';
import Banner from './shared/banner';
import CartPageContent from './shared/cartPage';
import CategorySecondContent from './shared/category-second-content';
import CategoryContent from './shared/categoryContent';
import FixedBottomNavbar from './shared/fixed-mobile-navbar';
import Footer from './shared/footer';
import GiftCard from './shared/giftCard';
import HeaderBottom from './shared/header-bottom';
import HeaderBottomMobile from './shared/header-bottom-mobile';
import HeaderTop from './shared/header-top';
import HeaderTopMobile from './shared/header-top-mobile';
import Installments from './shared/installments';
import MainPageContent from './shared/main-page-content';
import OrderPageContent from './shared/order-page-content';
import ProductDetails from './shared/product';
import Providers from './shared/providers';
import YandexMap from './shared/yandex-map';
import CustomAccordion from './ui/accordion';
import BestBuy from './ui/best-buy';
import BestCategoriesCarousel from './ui/best-category-carousel';
import Breadcrumbs from './ui/breadcrumbs';
import CustomCardCarousel from './ui/card-carousel';
import CardSecond from './ui/card-second';
import Carousel from './ui/carousel';
import CategoryCard from './ui/category-card';
import CustomCarouselCategory from './ui/category-carousel';
import CustomSelect from './ui/custom-select';
import CustomDefaultAccordion from './ui/CustomAccordion';
import CustomInput from './ui/CustomInput';
import MainPageCategories from './ui/main-page-categories';
import MiniProductCard from './ui/mini-product-card';
import CustomModal from './ui/modal-full';
import NewArrival from './ui/new-arrival';
import PasswordContent from './ui/password-content';
import PersonalCabinet from './ui/personal-cabinet-popup';
import PopularBrands from './ui/popular-brands';
import PopularCard from './ui/popular-card';
import ProfilePopupContent from './ui/profile-popup-content';
import CustomRadioButton from './ui/radio-button';
import { SearchInput } from './ui/search-input';
import { SearchInputMobile } from './ui/search-input-mobile';
import SharedCarousel from './ui/shares';
import SharesCard from './ui/shares-card';
import ShoppingCartContent from './ui/shopping-cart-content';
import CustomSkeleton from './ui/skeleton';
import CustomSlider from './ui/slider';
import StickyHeader from './ui/stickyHeader/stickyHeader';
import Thumbnails from './ui/thumbnails';
import TradeIn from './ui/trade-in';
// import CustomCitiesSelect from "./ui/custom-cities-select";
const CustomCitiesSelect = dynamic(() => import('./ui/custom-cities-select'), {
  ssr: false,
});

export {
  Banner,
  BestBuy,
  BestCategoriesCarousel,
  Breadcrumbs,
  CardSecond,
  Carousel,
  CartPageContent,
  CategoryCard,
  CategoryContent,
  CategorySecondContent,
  CustomAccordion,
  CustomCardCarousel,
  CustomCarouselCategory,
  CustomCitiesSelect,
  CustomDefaultAccordion,
  CustomInput,
  CustomModal,
  CustomRadioButton,
  CustomSelect,
  CustomSkeleton,
  CustomSlider,
  FixedBottomNavbar,
  Footer,
  GiftCard,
  HeaderBottom,
  HeaderBottomMobile,
  HeaderTop,
  HeaderTopMobile,
  Installments,
  MainPageCategories,
  MainPageContent,
  MiniProductCard,
  NewArrival,
  OrderPageContent,
  PasswordContent,
  PersonalCabinet,
  PopularBrands,
  PopularCard,
  ProductDetails,
  ProfilePopupContent,
  Providers,
  SearchInput,
  SearchInputMobile,
  SharedCarousel,
  SharesCard,
  ShoppingCartContent,
  StickyHeader,
  Thumbnails,
  TradeIn,
  YandexMap,
};
